






















import { Component, Prop, Vue } from "vue-property-decorator";
import { storePerawat } from "@/store/modules/perawat";
import { storeDokter } from "@/store/modules/dokter";
import {
  Person,
  resolveSelectedId,
  resolveEmit
} from "@/components/personAutoComplete.helpers";

@Component({
  components: {}
})
export default class PersonAutoComplete extends Vue {
  @Prop({ default: null }) value?: string | number | { id: number; nama: string };
  @Prop({ default: null }) label?: string;
  @Prop({ default: null }) placeholder?: string;
  @Prop({ default: "perawat" }) readonly source!: "perawat" | "dokter" | "karyawan";
  @Prop({ default: false }) needValidation?: boolean;
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop({ default: false }) readonly clearable?: boolean;
  @Prop({ default: () => [] }) readonly exclude?: Array<number>;
  // "id" (default) = v-model an id; "nama" = v-model a name string (drop-in for *_nama fields).
  @Prop({ default: "id" }) readonly valueMode!: "id" | "nama";

  loading = false;
  validasi = this.needValidation
    ? [v => !!v || `*Kolom ${this.label} Harus Diisi`]
    : [];

  get selectedId() {
    return resolveSelectedId(this.listPerson, this.value, this.valueMode);
  }
  set selectedId(id) {
    this.$emit("input", resolveEmit(this.listPerson, id, this.valueMode));
  }

  get placeholderText() {
    if (this.placeholder) {
      return this.placeholder;
    }
    if (this.source === "dokter") {
      return "Ketik nama dokter";
    }
    if (this.source === "karyawan") {
      return "Ketik nama petugas";
    }
    return "Ketik nama perawat";
  }

  get listPerson(): Person[] {
    let list: Person[];
    if (this.source === "dokter") {
      list = storeDokter.listAll as Person[];
    } else if (this.source === "karyawan") {
      list = storePerawat.listKaryawan as Person[];
    } else {
      list = storePerawat.listPerawat as Person[];
    }
    return list.filter(it => !this.exclude.includes(it.id));
  }

  mounted() {
    if (this.source === "dokter") {
      if (!storeDokter.listAll.length) {
        storeDokter.act_dokter_all();
      }
    } else if (this.source === "karyawan") {
      if (!storePerawat.listKaryawan.length) {
        storePerawat.actListKaryawanAll();
      }
    } else {
      if (!storePerawat.listPerawat.length) {
        storePerawat.actListPerawatall();
      }
    }
  }
}
